module.exports = __webpack_public_path__ + "assets/img/gw-select.cd169708.png";